<template lang="pug">
    .fixedHeader(ref="fixedHeader")
        .container
            slot
            app-header.black
</template>

<script>
    import Header from "./Header";
    import MonthsList from "../elements/MonthsList";
    export default {
        name: "EventFixedHeader",
        methods:{
            iniFixedtHeader() {
                let fixedHeader = this.$refs.fixedHeader,
                    headHeight = document.querySelector('.event .head').scrollHeight;

                let handler = (offset) => {
                    if (getComputedStyle(document.querySelector('#app')).position === 'fixed') return;
                    if (offset > headHeight * 0.8){
                        if (!fixedHeader.classList.contains('show')){
                            fixedHeader.classList.add('show');
                        }
                    }else {
                        fixedHeader.classList.remove('show');
                    }
                };

                window.addEventListener('scroll', () => {
                    handler(window.pageYOffset)
                })
            }
        },
        mounted(){
            this.iniFixedtHeader();
        },
        components: {MonthsList, appHeader: Header}
    }
</script>

<style scoped lang="scss">
    .fixedHeader{
        position: fixed;
        top: 0;
        left: 0;
        z-index: 10;
        width: 100vw;
        padding: 20px 0;
        background: #fff;
        transform: translate3d(0, -100%, 0);
        transition: .5s;
        display: none;
        &.show {
            transform: translate3d(0, 0, 0);
            box-shadow: 0 -1px 14px rgba(#24222a, 0.5);
        }
        .container{
            display: flex;
            align-items: center;
            justify-content: space-between;
            max-width: 102rem;
        }
        header{
            position: absolute;
            top: 0;
            right: 0;
        }
        @include razr768{
            padding: 28px 0;
        }
        @include razr360{
            padding: 25px 0;
        }
        @include mobile_or_P{
            display: block;
        }
    }
</style>
